// extracted by mini-css-extract-plugin
export var section = "what-module--section--3Cqbf";
export var sectionInner = "what-module--sectionInner--1GwID";
export var sectionContent = "what-module--sectionContent--1FTyc";
export var pointsList = "what-module--pointsList--1s1p5";
export var pointsItem = "what-module--pointsItem--ow8Hu";
export var pointsItemArrow = "what-module--pointsItemArrow--1yfOq";
export var pointsItemCopy = "what-module--pointsItemCopy--1cfaW";
export var mediaContainer = "what-module--mediaContainer--2_omq";
export var mediaShape = "what-module--mediaShape--VdO2k";
export var mediaShape1 = "what-module--mediaShape1--3QhPJ";
export var mediaShapeMedia = "what-module--mediaShapeMedia--3Eu5l";
export var mediaShape2 = "what-module--mediaShape2--3Xymc";
export var mediaShape3 = "what-module--mediaShape3--2cugh";